import { STATICPAGELOADER } from './loader.types'

export default (state, action) => {
    switch (action) {
        case STATICPAGELOADER:
            return {
                ...state,
                isStaticPageLoad: action.payload,
            }
        default:
            return state
    }
}
